import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { CourseContext } from "./CourseContext";
import { SliderBigText } from "./SliderBigText";
import { TrainingProgram } from "./TrainingProgram";
import s from '../CourseDetail.module.css';
import { useAppTranslation } from "./TranslationContext";
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

export const CourseDetail = () => {
  const { user, handleLang } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const courses = useContext(CourseContext);
  const course = courses.find(c => c.id === parseInt(id));
  const { t } = useAppTranslation();

  const [dataAvz, setDataAvz] = useState([]);
  const [avzalliklar, setAvzalliklar] = useState([]);

  const [dataDesc, setDataDesc] = useState([]);
  const [description, setDescription] = useState({});

  const [loading, setLoading] = useState(true);
  const [loadingDesc, setLoadingDesc] = useState(true);
  const [error, setError] = useState(null);
  const [errorDesc, setErrorDesc] = useState(null);

  const [author, setAuthor] = useState(null);
  const [loadingAuthor, setLoadingAuthor] = useState(false);
  const [errorAuthor, setErrorAuthor] = useState(null);

  // Загружаем данные курсов и описаний
  useEffect(() => {
    fetch("https://api.rasulova-academy.uz/api/kurs-avzallik/")
      .then((res) => {
        if (!res.ok) throw new Error(t('networkError') + res.status);
        return res.json();
      })
      .then((json) => {
        setDataAvz(json);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });

    fetch("https://api.rasulova-academy.uz/api/kurs-big-description/")
      .then((res) => {
        if (!res.ok) throw new Error(t('networkError') + res.status);
        return res.json();
      })
      .then((json) => {
        setDataDesc(json);
        setLoadingDesc(false);
      })
      .catch((err) => {
        setErrorDesc(err.message);
        setLoadingDesc(false);
      });
  }, [t]);

  // Обработка avzalliklar
  useEffect(() => {
    if (!loading && dataAvz.length > 0) {
      const filtered = dataAvz
        .filter(item => item.kurs.id == id)
        .map(i => ({
          id: i.id,
          kurs_id: i.kurs.id,
          title_uz: i.nomi_uz,
          title_ru: i.nomi_ru,
          title_en: i.nomi_en,
          desc_uz: i.description_uz,
          desc_ru: i.description_ru,
          desc_en: i.description_en,
          img_uz: i.img_uz,
          img_ru: i.img_ru,
          img_en: i.img_en
        }));
      setAvzalliklar(filtered);
    }
  }, [dataAvz, loading, id]);

  // Обработка description
  useEffect(() => {
    if (!loadingDesc && dataDesc.length > 0) {
      const desc = dataDesc.find(i => i.kurs.id == id);
      if (desc) {
        setDescription({
          id: desc.id,
          kurs_id: desc.kurs.id,
          title_uz: desc.nomi_uz,
          title_ru: desc.nomi_ru,
          title_en: desc.nomi_en,
          img_uz: desc.img_uz,
          img_ru: desc.img_ru,
          img_en: desc.img_en,
          desc_uz: desc.description_uz,
          desc_ru: desc.description_ru,
          desc_en: desc.description_en
        });
      }
    }
  }, [dataDesc, loadingDesc, id]);

  // Загружаем автора после того, как найден курс
  useEffect(() => {
    if (course?.author?.id) {
      setLoadingAuthor(true);

      const fetchAuthorData = async () => {
        try {
          // 1. Данные из custom-users
          const resCustom = await fetch(`https://api.rasulova-academy.uz/api/custom-users/?user=${course.author.id}`);
          if (!resCustom.ok) throw new Error('Ошибка при загрузке custom-user');
          const customData = await resCustom.json();
          const customUser = Array.isArray(customData) ? customData[0] : customData;

          // 2. Данные из users
          const resUser = await fetch(`https://api.rasulova-academy.uz/api/users/${course.author.id}/`);
          if (!resUser.ok) throw new Error('Ошибка при загрузке user');
          const userData = await resUser.json();

          // 3. Объединяем данные
          setAuthor({
            ...customUser,
            ...userData
          });

          setLoadingAuthor(false);
        } catch (err) {
          setErrorAuthor(err.message);
          setLoadingAuthor(false);
        }
      };

      fetchAuthorData();
    }
  }, [course]);

  console.log(author)
  const handleComment = () => {
    const token = localStorage.getItem('token');
    const userId = user?.id;

    if (!token || !userId) {
    const token = localStorage.getItem('token');
      toast.warn(t('alertLogin'));
      return;
    } else {
      navigate(`/courseComment/${id}`);
    }
  }


  const handleEnroll = async () => {
    const token = localStorage.getItem('token');
    const userId = user?.id;

    if (!token || !userId) {
      toast.warn(t('alertLogin'));
      return;
    }

    try {
      const res = await fetch(`https://api.rasulova-academy.uz/api/user-kurs/?user=${userId}&kurs=${id}`, {
        headers: {
          'Authorization': `Token ${token}`
        }
      });

      const data = await res.json();

      if (data.length > 0) {
        navigate(`/themes/${id}`);
      } else {
        const postRes = await fetch('https://api.rasulova-academy.uz/api/user-kurs/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
          },
          body: JSON.stringify({
            user: userId,
            kurs: parseInt(id),
            mavzu: 1
          })
        });

        if (!postRes.ok) {
          const errorData = await postRes.json();
          console.error("Ошибка при создании:", errorData);
          toast.error("Ошибка при записи на курс.");
        } else {
          toast.success("Вы успешно записались на курс!");
          navigate(`/themes/${id}`);
        }
      }

    } catch (error) {
      console.error(t('networkError'), error);
      toast.error("Произошла ошибка. Попробуйте позже.");
    }
  };

  if (!course) return <p>Курс не найден</p>;
  if (error) return <p>Ошибка: {error}</p>;
  if (errorDesc) return <p>Ошибка: {errorDesc}</p>;

  return (
    <div>
      <div className={s.start__screen}>
        <section className={s.sec1}>
          <div className={s.start__screen__contents}>
            <p className={s.st__content}>
              {course.duration + " " + t('courseSubtitle')}
            </p>
            <p className={s.nd__content}>
              {handleLang(course.title_uz, course.title_ru, course.title_en)}
            </p>
            <div className="course__btns">
              <button className="register__btn btn__passive bgcinh" onClick={handleComment}>
                {/* {t('courseLink')} */}
                {t('courseRate')}
              </button>
              <button className={s.start__screen__link} onClick={handleEnroll}>
                {t('courseLink')}
              </button>
            </div>
          </div>
          <div className={s.start__screen__img}>
            <img src={course.img_uz} alt="" />
          </div>
        </section>

        <section className={s.sec2}>
          <div className={s.cards}>
            {avzalliklar.map((avz, index) => (
              <div key={index} className={s.card}>
                <p className={s.card__title}>{handleLang(avz.title_uz, avz.title_ru, avz.title_en)}</p>
                <p className={s.card__txt}>{handleLang(avz.desc_uz, avz.desc_ru, avz.desc_en)}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      <div className="container">
        <div className={s.section2}>
          <p className={s.title}>
            {handleLang(description.title_uz, description.title_ru, description.title_en)}
          </p>
          <div className={s.squares}>
            <img className={s.squares__img} src={description.img_uz} alt="" />
            <div className={s.square__infs}>
              <div className={`${s.square__inf} ${s.square__inf1} ${s.square__inf__txt}`}>
                {handleLang(description.desc_uz, description.desc_ru, description.desc_en)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <SliderBigText />

      {/* author */}
      <section className="author container">
        <h2 className={s.title}>{t('author')}</h2>
        {loadingAuthor && <p>Загрузка автора...</p>}
        {errorAuthor && console.log('Ошибка:', {errorAuthor})}
        {author && (
          <div className="author-block">
            <img src={author.img || "/images/author.jpg"} alt="" className="author-img" />
            <div className="author-content">
              <p className="author-name">
                {handleLang(author.first_name, author.first_name, author.first_name)} {handleLang(author.last_name, author.last_name, author.last_name)}
              </p>
              <p className="author-desc">
                {author.description || ""}
              </p>
            </div>
          </div>
        )}
      </section>

      <TrainingProgram />
    </div>
  );
};
